
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface ActionButtonsProps {
  onOpenChange: (isOpen: boolean) => void;
  onDeleteItem: () => void;
  isSubmitting: boolean;
}

const ActionButtons = ({
  onOpenChange,
  onDeleteItem,
  isSubmitting
}: ActionButtonsProps) => {
  const { theme } = useThemeConfig();
  const [showConfirm, setShowConfirm] = useState(false);
  return (
    <div className="flex justify-between gap-2 pt-4">
      <Button
        type="button"
        variant="destructive"
        onClick={() => setShowConfirm(true)}
        className="flex-1"
      >
        Elimina dalla Lista
      </Button>

      <Button
        type="button"
        variant="outline"
        onClick={() => onOpenChange(false)}
        disabled={isSubmitting}
        className="flex-1"
              style={{
                backgroundColor: theme.backgroundColor,                
                color: theme.textColor,                
                borderRadius: theme.buttonBorderRadius,
                padding: theme.buttonPadding,
                fontWeight: theme.buttonFontWeight,
                transitionDuration: theme.transitionSpeed,
                '--btn-bg-hover': theme.primaryColor,
              } as React.CSSProperties}

      >
        Annulla
      </Button>

      <Button
        type="submit"
        className="hover:bg-[var(--btn-bg-hover)] flex-1"
              style={{
                backgroundColor: theme.primaryColor,
                color: theme.textPrimaryColor || theme.textColor,
                borderRadius: theme.buttonBorderRadius || '0.375rem',
                padding: theme.buttonPadding || '0.5rem 1rem',
                fontWeight: theme.fontWeightNormal || '400',
                transitionDuration: theme.transitionSpeed || '0.2s',
                '--btn-bg-hover': theme.primaryColor,
              } as React.CSSProperties}
        disabled={isSubmitting}
      >
        Salva
      </Button>
      {showConfirm && (
        <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
          <AlertDialogContent style={{ backgroundColor: theme.backgroundColor }}>
            <AlertDialogHeader>
              <AlertDialogTitle>Confermi l'eliminazione?</AlertDialogTitle>
              <AlertDialogDescription style={{ color: theme.sectionTitleColor }}>
                Questa azione è irreversibile. L’elemento sarà rimosso definitivamente.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Annulla</AlertDialogCancel>
              <AlertDialogAction
                variant="destructive"
                onClick={() => {
                  setShowConfirm(false);
                  onDeleteItem();
                }}
              >
                Conferma
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
};

export default ActionButtons;
